module.exports = {
	"base": {
		"welcome": "Mulligans में आपका स्वागत है, %{name}!",
		"user": "उपयोगकर्ता की जानकारी",
		"devices": "डिवाइसेस",
		"refunds": "रिफंड",
		"resources": "संसाधन",
		"transactions": "ऑर्डर और रिटर्न",
		"email": "ईमेल",
		"password": "पासवर्ड",
		"save": "सहेजें",
		"sign-out": "साइन आउट करें",
		"cancel": "रद्द करें",
		"close": "बंद करें",
		"learn-more": "अधिक जानें",
		"required": "आवश्यक",
		"support": "समर्थन करें",
		"bookshelf": "बुकशेल्फ़",
		"launch": "लॉन्च करें",
		"download": "डाउनलोड करें",
		"details": "विवरण",
		"cannot-be-blank": "%{field} खाली नहीं हो सकता.",
		"saving": "सहेजा जा रहा है...",
		"done": "संपन्न",
		"failed": "विफल",
		"copy": "कॉपी करें"
	},
	"signin": {
		"login-failure": "ईमेल या पासवर्ड गलत है",
		"welcome-large": "%{brand} खाता केंद्र <span class='inner'>में आपका स्वागत है</span>",
		"welcome-small": "<span class='inner'>खाता केंद्र</span>",
		"signin-button": "साइन इन करें",
		"forgot-password": "पासवर्ड भूल गए",
		"new-to-vst": "क्या आप %{brand} में नए हैं?",
		"create-account": "खाता बनाएं",
		"signing-in": "साइन इन किया जा रहा है...",
		"signin-failed": "साइन इन विफल हुआ"
	},
	"transactions": {
		"price": "मूल्य",
		"excluded": "(कर सहित)",
		"quantity": "मात्रा",
		"confirmation#": "पुष्टिकरण #",
		"payment": "भुगतान",
		"purchased": "खरीदा गया",
		"purchase-details": "खरीदारी का विवरण",
		"subtotal": "पूर्ण योग",
		"total": "कुल योग",
		"tax": "कर",
		"loading": "बड़ा खर्च करने वाले, हम आपके लेनदेन लोड कर रहे हैं...",
		"no-purchases": "आपने कुछ नहीं खरीदा है.",
		"seller-vat": "विक्रेता VAT",
		"total-vat": "कुल %{vat} का भुगतान किया गया",
		"portion": "%{subTax} कर %{rate}%",
		"vat-disclosure": "मूल्य में शामिल है %{vat}",
		"purchases": "खरीदियां",
		"refunded-items": "शुल्कवापसी किए गए आइटम",
		"book-title": "पुस्तक का शीर्षक",
		"refund-details": "रिफंड विवरण",
		"print-receipt": "रसीद प्रिंट करें",
		"request-refund": "शुल्कवापसी का अनुरोध करें",
		"expired": "समय समाप्त हुआ ",
		"expires-in": "%{date} को समाप्त",
		"details-refund": "जानकारी और रिफ़ंड",
		"modal": {
			"cant-refund-title": "रिफंड उपलब्ध नहीं है",
			"cant-refund": "आपकी पुस्तक निम्नलिखित एक या अधिक कारणों से रिफंड नहीं हो सकती.",
			"cant-refund-1": "आपकी बहुत सी पुस्तकें देखी गई हैं.",
			"cant-refund-2": "क्रय तिथि के बाद 14 दिन से अधिक समय हो चुका है.",
			"cant-refund-3": "आपके ऑनलाइन संसाधन कोड का पता चल गया है.",
			"cant-refund-4": "आपकी पुस्तक पहले रिफंड हो चुकी है.",
			"cant-refund-5": "सभी कोड को पहले ही रिडीम और/या वापस कर दिया गया है.",
			"cant-refund-6": "क्रय तिथि से 30 दिन से अधिक हो चुके हैं.",
			"cant-refund-support": "अगर आप अभी भी %{brand} की धनवापसी नीति के <a href='%{support_url}' target='_blank'>प्रति सुनिश्चित नहीं हैं,</a> तो सहायता से संपर्क करें."
		},
		"license": {
			"perpetual": "ऑनलाइन एक्सेस कोड की समय-सीमा समाप्त नहीं होती है",
			"days": "%{days} दिन का एक्सेस"
		}
	},
	"devices": {
		"description": "%{brand} आपको %{desktop} कंप्यूटर और <span>%{mobile} मोबाइल/टैबलेट डिवाइस को</span> किसी भी समय <span>सक्रिय करने की</span> अनुमति देता है.",
		"loading": "नमस्कार, हमें आपके डिवाइसेज़ मिल रहे हैं :)",
		"no-active": "आपको कोई डिवाइस सक्रिय नहीं हैं.",
		"deactivate": "निष्क्रिय करें"
	},
	"user": {
		"personal-information": "व्यक्तिगत जानकारी",
		"security-information": "सुरक्षा जानकारी",
		"notifications": "सूचनाएं",
		"first-name": "पहला नाम",
		"last-name": "अंतिम नाम",
		"change-password-title": "पासवर्ड बदलें",
		"current-password": "वर्तमान पासवर्ड",
		"new-password": "नया पासवर्ड",
		"security-password": "पासवर्ड",
		"confirm-new-password": "नए पासवर्ड की पुष्टि करें",
		"security-question": "सुरक्षा प्रश्न",
		"security-info-change": "बदलें",
		"question": "प्रश्न",
		"answer": "उत्तर",
		"notifications-text": "मेरी खाता गतिविधि, उत्पाद अपडेट और विशेष ऑफ़र के बारे में समय-समय पर अपडेट मुझे ईमेल करें.",
		"loading": "स्थान आपकी उपयोगकर्ता जानकारी निकाल रहा है, एक सेंकड 🐶",
		"change-password-text": "पासवर्ड में कम से कम 8 वर्ण, एक बड़ा अक्षर, एक छोटा अक्षर, और एक विशेष वर्ण होना चाहिए.",
		"email-locked": "ईमेल लॉक किया गया",
		"email-locked-description": "आपके पास अपना ईमेल बदलने का एक्सेस नहीं है.",
		"email-locked-more": "कृपया अपने व्यवस्थापक से संपर्क करें।",
		"security-question6": "आपका पसंदीदा खेल क्या है?",
		"security-question7": "आपका पसंदीदा आइसक्रीम फ्लेवर क्या है?",
		"security-question8": "आपके पसंदीदा पालतू पशु का नाम क्या है?",
		"security-question9": "जब आप छोटे थे तो बड़े होकर आप क्या बनना चाहते थे?",
		"security-question10": "आपके पसंदीदा टीचर का नाम क्या था?",
		"new-password-failure": "पासर्ड आवश्यकताएं पूरी नहीं करता है",
		"confirm-password-failure": "पासवर्ड मेल खाना चाहिए",
		"new-password-tooltip": "कम से कम 8 वर्ण, एक अपरकेस अक्षर, एक लोअरकेस अक्षर, और एक विशेष वर्ण शामिल होना चाहिए.",
		"enter-valid-email": "कृपया एक मान्य ईमेल दर्ज करें.",
		"password-cannot-be-same": "नया पासवर्ड पिछले पासवर्ड के समान नहीं हो सकता.",
		"incorrect-password": "गलत पासवर्ड",
		"complete-account": "लगता है आपको <a href='%{href}'>अपना खाता पूरा करना होगा</a>।",
		"completing-allows": "अपना खाता पूरा करने से आपके लिए हमारे मोबाइल ऐप्स पर ऑफलाइन किताबें पढ़ना और दोस्तों के साथ नोट्स व झलकियां साझा करना संभव होगा।",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "सहायक",
		"access-codes": "एक्सेस कोड",
		"print-on-demand": "मांग पर प्रिंट करें",
		"check-pod": "अपने पुस्तकों के लिए प्रकाशक प्रिंटिंग विकल्पों को जाँचें.",
		"check-now": "अभी जांचें",
		"loading": "प्रतीक्षा करें, हम आपके संसाधन अपडेट कर रहे हैं!",
		"in": "in",
		"access-code-intro": "एक्सेस कोड एक ऐसा पासवर्ड है, जिसका उपयोग आप पाठ्यक्रम सामग्री तक ऑनलाइन पहुँच प्राप्त करने के लिए कर सकते हैं. जैसे ही आप किसी आइटम के लिए एक कोड प्रकट करते हैं, आप उसे वापस नहीं कर सकेंगे. अपने एक्सेस को़ड्स का उपयोग करने के तरीके के बारे में अधिक निर्देशों के लिए, <a href='%{support_url}' target='_blank'>सहायता पर जाएं</a>.",
		"expires": "समापन तिथि",
		"expiration-message": "इसमें आपके एक्सेस को़ड का उपयोग करने के बारे में निर्देश होते हैं.",
		"copy-fail": "कॉपी करने में असमर्थ है. कृपया कोड चुनें और उसे मैनुअल रूप से कॉपी करें.",
		"launch-site": "साइट लॉन्च करें",
		"launch-book": "लॉन्च बुक",
		"reveal-code": "कोड प्रकट करें",
		"no-resources": "आपके पास कोई संसाधन नहीं हैं.",
		"no-access-codes": "आपको पास कोई एक्सेस कोड नहीं हैं.",
		"no-ancillaries": "इस शीर्षक के लिए कोर्ई एंसिलरी नहीं है",
		"name": "नाम",
		"type": "प्रकार",
		"size": "आकार",
		"download-all": "सब डाउनलोड करें",
		"back": "संसाधनों पर वापस"
	},
	"refunds": {
		"states": {
			"refunded": "रिफंड किये गए",
			"unavailable": "रिफंड उपलब्ध नहीं है"
		},
		"reasons": {
			"dropped": "मैनें पाठ्यक्रम छोड़ दिया",
			"wrong": "यह मेरे पाठ्यक्रम के लिए गलत पुस्तक थी",
			"print": "इसके बजाय मैंने मुद्रित संस्करण खरीदने के निर्णय लिया",
			"missing": "इस पुस्तक में सब कुछ नहीं है जिसकी मुझे अपने पाठ्यक्रम के लिए जरूरत है (उदा. CD, वेब एक्सेस, वीडियो)",
			"other": "अन्य"
		},
		"bulk": {
			"policy": "नीचे दिया गया &quot;पूरा रिफंड&quot; बटन क्लिक कर मैं %{brand} <a href='%{policy_url}' target='_blank'>की रिफंड संबंधी नीति</a>पर अपनी सहमति देता/देती हूं.",
			"complete": "पूरा रिफंड",
			"view-details": "रिफंड का विवरण देखें",
			"success": "आपके रिफ़ंड की मांग की गई है. प्रोसेसिंग के लिए कृपया 48 घंटे तक इंतज़ार करें.",
			"failure": "उफ - कुछ गलत हो गया! दुर्भाग्यवश आपका रिफंड ठीक से नहीं हो सका.",
			"retry": "पुनः प्रयास करें",
			"support": "संपर्क सहायता",
			"available-codes": "उपलब्ध कोड",
			"codes-selected": "कोड चयनित",
			"download": "कोड डाउनलोड करें",
			"partially-refunded": "आंशिक रूप से रिफंड किया गया",
			"pick-one": "आपको रिफंड करने के लिए कम से कम एक कोड का चयन करना होगा "
		},
		"refund": "रिफंड",
		"all": "सब रिफंड करें?",
		"missing-reason": "जारी रखने के लिए आपको एक कारण चुनना होगा",
		"missing-elaboration": "कृपया विस्तार से बताएं",
		"policy": "नीचे दिया गया “धनवापसी अनुरोध पूर्ण करें” बटन क्लिक करके मैं समझता/समझती हूं कि अगर मैं फिर से इस %{brand} ईटेक्स्ट बुक की खरीदारी करता/करती हूं, तो मैं समान ई-टेक्स्टबुक के लिए अधिक धनवापसी का अनुरोध नहीं कर पाऊंगा/पाऊंगी. पूरी वापसी नीति देखें.",
		"refunded": "रिफंड किये गए",
		"sorry": "हमें खेद है कि आप अपनी खरीदारी से संतुष्ट नहीं हुए.",
		"error": "कुछ गलत हुआ",
		"error-explain": "हम आपका रिफंड संसाधित करने में असमर्थ थे. कृपया फिर से प्रयास करें.",
		"why": "हमें बताएं क्यों?",
		"no-refunds": "आपके कोई रिफंड किये गए आइटम नहीं हैं.",
		"select-codes": "रिफंड के लिए कोड का चयन करें:",
		"number": "कितने?",
		"back": "रिफंड पर वापस"
	},
	"purchases": {
		"back": "खरीद पर वापस"
	},
	"global-bar": {
		"account": "खाता सेटिंग"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/hi.json
 ** module id = 986
 ** module chunks = 0
 **/